import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Estudo } from './estudo';
import { EstudoService } from './estudo.service';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { Questionario } from 'unb-questionario-componente';
import { EstudoQuestionario } from './estudo-questionario';
import { EstudoQuestionarioEnum } from  '../util/estudo-questionario.enum';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { MatDialog } from '@angular/material';


@Component({
  templateUrl: './estudo-preliminar-detail.component.html',
	selector: 'estudo-preliminar-detail',
})
export class EstudoPreliminarDetailComponent implements OnInit {
    @Input() estudo : Estudo;
    @Input() ehAluno : boolean ;
    @Output() estudoEmitido: EventEmitter<Estudo> = new EventEmitter<Estudo>();
    @Output() questionarioPreliminarEmitido: EventEmitter<Questionario> = new EventEmitter<Questionario>();

    @Output() proximoEmitido: EventEmitter<number> = new EventEmitter<number>();
    @Output() anteriorEmitido: EventEmitter<number> = new EventEmitter<number>();

    public resposta : Resposta;
    public isLoading: boolean;
    public mostrarSalvar: boolean;
    private mensagemTela: string;
    private questionarioCompleto:Questionario;
    private classProximo: string;

    constructor(
      private estudoService: EstudoService,
      private mensagem: MatSnackBar,
      private respostaService: RespostaListaDinamicaService,
      public dialog: MatDialog)  {
    }

  ngOnInit() {
      if(this.estudo){
        this.classProximo = "disabled";
        this.carregaQuestionario();
        this.controlaSalvar();
      }else{
        this.mensagemTela = "Erro ao carregar estudo. Por favor, tente novamente. Se o problema persistir, consulte o CPD";
      }
  }

  carregaQuestionario(): void{
    // vejo se a classe pai jah tem o questionario Preliminar preenchido.
    if(this.estudo.questionarioPreliminar){
      this.carregaQuestionarioPeloPai();
    }else{ // se nao tiver, entao carrego ele aki em baixo.
      this.carregaQuestionarioPeloServico();
    }
  }

 carregaQuestionarioPeloServico(){
   this.isLoading= true;
   this.estudoService.getQuestionario(this.estudo.respostaQuestionarioPreliminar, null, EstudoQuestionarioEnum.estudoPreliminar)
     .subscribe((result: EstudoQuestionario) =>{
       this.questionarioCompleto = result.questionario;
       // emito o questionario montado pra classe pai. Assim, nao vou precisar carregar esse metodo novamente
       this.questionarioPreliminarEmitido.emit(result.questionario);
       if(result.resposta){
         this.resposta = result.resposta;
       }
       this.carregaMensagem(this.estudo.respostaQuestionarioPreliminar);
   },
   error =>  this.erro(error));
 }

 carregaQuestionarioPeloPai(){
   this.questionarioCompleto = this.estudo.questionarioPreliminar
   if(this.estudo.respostaQuestionarioPreliminar){
     this.isLoading= true;
     this.carregaResposta();
   }
 }

  carregaResposta(): void{
    if(this.estudo.respostaQuestionarioPreliminar){
      this.respostaService.getRespostaCompletaPorPergunta(this.estudo.respostaQuestionarioPreliminar).subscribe(
        result =>{
          this.resposta = result;
          this.carregaMensagem(this.estudo.respostaQuestionarioPreliminar);
        },
        error =>  this.erro(error),
      );
    }
  }

  estudoPreliminarEmitido(event: number): void{
      this.estudo.respostaQuestionarioPreliminar = event;
      this.estudoService.update(this.estudo).subscribe(
        result => {
          this.estudo = result;
          if(this.questionarioCompleto){
            this.estudo.questionarioPreliminar =  this.questionarioCompleto;
          }
          this.estudoEmitido.emit(this.estudo);
          this.controlaSalvar();
          this.carregaMensagem(this.estudo.respostaQuestionarioPreliminar);
        },
        error => this.erro(error)
      );
  }

  controlaSalvar(): void{
    if(this.estudo && this.estudo.respostaQuestionarioPreliminar){
      // se jah existir resposta, entao soh o profissional pode ver o salvar
      if(this.ehAluno){
        this.mostrarSalvar = false;
      }else{
        this.mostrarSalvar = true;
      }
    }else{
      this.mostrarSalvar = true;
    }
  }

  carregaMensagem(idResposta : number): void{
    if(this.estudo.id && this.estudo.respostaQuestionarioPreliminar){
      this.estudoService.verificaPerfilEstudoPreliminar(this.estudo.id).subscribe((result: boolean) =>{
          if(result == true){
            this.mensagemTela = "Você possui perfil socioeconômico. Por favor, preencha os formulários da Seção '3. DADOS PESSOAIS'";
            this.classProximo = "";
          }else{
            this.mensagemTela = "Você não possui perfil socioeconômico.";
            // a assistente pode ir pro proximo. O Aluno nao.
            if(this.ehAluno){
              this.classProximo = "disabled";
            }
          }
          this.isLoading= false;
        },   error =>  this.erro(error)
      );
    }else{
      this.isLoading= false;
    }
  }

  proximo(){
    if(this.classProximo == ""){
      this.proximoEmitido.emit(2);
    }else{
      let confirmacao: Confirmacao;
      if(this.mensagemTela && this.mensagemTela == "Você não possui perfil socioeconômico."){
        confirmacao= new Confirmacao("Você não possui perfil socioeconômico e não pode continuar.", true);
      }else{
        confirmacao= new Confirmacao("Primeiro você deve clicar no botão 'Salvar' para continuar.", true);
      }

      let dialogRef = this.dialog.open(ConfirmacaoDialog, {
          width: '400px',
          data: confirmacao,
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result){
          }
        });
    }
  }

  anterior(){
    this.anteriorEmitido.emit(2);
  }


    // mostra erros na tela
   erro(erro: string): void{
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading= false;
   }


}
